import React, { useState } from "react";
import "../../css/Features_New.css";
import { motion, AnimatePresence } from "framer-motion";
import { FiZap, FiCheckCircle, FiSmile, FiClock } from "react-icons/fi";

export const Features_New = () => {
  const [activeFeature, setActiveFeature] = useState(0);

  const features = [
    {
      icon: <FiZap />,
      title: "Fast Loan Processing",
      desc: "Applications are processed quickly to ensure faster approvals and disbursals.",
      color: "#0ca2b8",
      bgImage: "radial-gradient(circle at top right, rgba(12, 162, 184, 0.08) 0%, transparent 70%)"
    },
    {
      icon: <FiSmile />,
      title: "Convenient & Reliable",
      desc: "A streamlined digital process designed for ease, comfort, and peace of mind.",
      color: "#10b981",
      bgImage: "radial-gradient(circle at top right, rgba(16, 185, 129, 0.08) 0%, transparent 70%)"
    },
    {
      icon: <FiCheckCircle />,
      title: "Simple & Hassle-Free",
      desc: "No complicated paperwork or unnecessary steps involved in the entire process.",
      color: "#f59e0b",
      bgImage: "radial-gradient(circle at top right, rgba(245, 158, 11, 0.08) 0%, transparent 70%)"
    },
    {
      icon: <FiClock />,
      title: "Quick Access to Funds",
      desc: "Get the financial support you need immediately without long waiting times.",
      color: "#8b5cf6",
      bgImage: "radial-gradient(circle at top right, rgba(139, 92, 246, 0.08) 0%, transparent 70%)"
    }
  ];

  return (
    <section className="fn_v5_wrapper">
      <div className="fn_v5_container">

        <div className="fn_v5_header">
          <motion.span
            className="fn_v5_badge"
            initial={{ opacity: 0, letterSpacing: "10px" }}
            whileInView={{ opacity: 1, letterSpacing: "4px" }}
            viewport={{ once: true }}
          >
            WHY CHOOSE ACTOLOAN
          </motion.span>
          <motion.h2
            className="fn_v5_title"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            Experience a <br />
            <span className="text_gradient_cyan">Better Way to Borrow.</span>
          </motion.h2>
        </div>

        <div className="fn_v5_layout">

          {/* Left Side: Interactive Tabs */}
          <div className="fn_v5_tabs">
            {features.map((item, index) => (
              <motion.div
                key={index}
                className={`fn_v5_tab ${activeFeature === index ? 'active' : ''}`}
                onMouseEnter={() => setActiveFeature(index)}
                onClick={() => setActiveFeature(index)}
              >
                <div className="fn_tab_icon" style={{
                  color: activeFeature === index ? '#ffffff' : item.color,
                  background: activeFeature === index ? item.color : `${item.color}15`
                }}>
                  {item.icon}
                </div>
                <div className="fn_tab_content">
                  <h3>{item.title}</h3>
                </div>
                {activeFeature === index && (
                  <motion.div layoutId="fn_active_indicator" className="fn_active_bg" style={{ borderColor: `${item.color}33` }} />
                )}
              </motion.div>
            ))}
          </div>

          {/* Right Side: Dynamic Display Panel */}
          <div className="fn_v5_display">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeFeature}
                className="fn_display_card"
                initial={{ opacity: 0, x: 20, scale: 0.95 }}
                animate={{ opacity: 1, x: 0, scale: 1 }}
                exit={{ opacity: 0, x: -20, scale: 0.95 }}
                transition={{ duration: 0.4, ease: "easeOut" }}
                style={{
                  backgroundImage: features[activeFeature].bgImage,
                  borderColor: `${features[activeFeature].color}33`
                }}
              >
                <div className="fn_display_icon" style={{ color: features[activeFeature].color }}>
                  {features[activeFeature].icon}
                </div>
                <div className="fn_display_text">
                  <h3 style={{ color: features[activeFeature].color }}>{features[activeFeature].title}</h3>
                  <p>{features[activeFeature].desc}</p>
                </div>

                {/* Decorative Abstract Elements */}
                <div className="fn_deco_circle_1" style={{ border: `1px solid ${features[activeFeature].color}33` }}></div>
                <div className="fn_deco_circle_2" style={{ border: `1px solid ${features[activeFeature].color}22` }}></div>
              </motion.div>
            </AnimatePresence>
          </div>

        </div>

      </div>
    </section>
  );
};
